export const ENV = (getEnv('ENVIRONMENT') || getEnv('ENV') || 'production').trim();
export const BUILD_NUMBER = getEnv('BUILD_NUMBER', '').trim();

export const SENTRY_KEY = getEnv('SENTRY_KEY', '').trim();

export const FABRICA_BASE_URL = getEnv('FABRICA_BASE_URL', '').trim();
export const API_SOCKET_URL = getEnv('API_SOCKET_URL', '').trim();
export const CDN_BASE_URL = getEnv('CDN_BASE_URL', '').trim();

export const IS_DEV = ENV === 'development';
export const IS_PROD = ENV === 'production';
export const IS_HOMOL = !IS_DEV && !IS_PROD;

export const IS_STAGE = ENV === 'stage';

export const DOMAIN = getEnv('DOMAIN', '').trim();
export const MAIN_SUBDOMAIN = getEnv('MAIN_SUBDOMAIN', '').trim();
export const isMainSubdomain = window.location.host === `${MAIN_SUBDOMAIN}${DOMAIN}`;

export const ACCOUNTS_TOKEN = getEnv('ACCOUNTS_TOKEN', '');

export const IS_MOBILE = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
  navigator.userAgent.toLowerCase()
);

export const NOTIFICATION_CENTER_URL = getEnv('NOTIFICATION_CENTER_URL', '').trim();

export const API_BASE_URL = getEnv('API_BASE_URL', '').trim();
export const API_V4_BASE_URL = getEnv('API_V4_BASE_URL', '').trim();
export const V3_URL = getEnv('V3_URL', '').trim();

export const TERMS_URL = getEnv('TERMS_URl', 'https://www.eduzz.com/termos-e-condicoes').trim();
export const PRIVACY_URL = getEnv('PRIVACY_URL', 'https://www.eduzz.com/politica-de-privacidade').trim();
export const COOKIES_URL = getEnv('COOKIES_URL', 'https://www.eduzz.com/pt-br/legal/cookies').trim();
const HOUSTON_CDN_URL = getEnv('HOUSTON_CDN_URL', '').trim();

export const NUTROR_LOGO = `${HOUSTON_CDN_URL}/topbar/logos/logo-nutror-light.svg`;

export const ACCOUNTS_AMBIENT = getEnv('ACCOUNTS_AMBIENT');

export const SUBDOMAIN_BLACKLIST = (getEnv('SUBDOMAIN_BLACKLIST') ?? '').split(',');

export const INSTITUCIONAL_BANNER = getEnv('INSTITUCIONAL_BANNER');

export const tokenKeysName = {
  token: 'newAuthToken',
  expiration: 'tokenExp',
  refreshToken: 'refreshToken'
};

function getEnv(env: string, defualtValue?: any) {
  return import.meta.env[`VITE_${env}`] || defualtValue;
}
